import { render, staticRenderFns } from "./ruleTable.vue?vue&type=template&id=6dabe1de&"
import script from "./ruleTable.vue?vue&type=script&lang=js&"
export * from "./ruleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports